import { Http } from '@mygpt/app/http';

/**
 * 获取api keys列表
 * @param params
 * @returns
 */
export const getApiKeys = (withSuperAdmin = false) => {
  const { get } = Http.use();
  return get(`/auth/keys?with_super_admin=${withSuperAdmin}`);
};

/**
 * 创建api key
 * @param params
 * @returns
 */
export const createApiKeys = (withSuperAdmin = false) => {
  const { post } = Http.use();
  return post(`/auth/keys`, { with_super_admin: withSuperAdmin });
};

export interface DeleteApiKeysParams {
  apiKey: string;
  withSuperAdmin?: boolean;
}

/**
 * 删除api key
 * @param params
 * @returns
 */
export const deleteApiKeys = (params: DeleteApiKeysParams) => {
  const { apiKey, withSuperAdmin } = params;
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/auth/keys/${apiKey}?with_super_admin=${withSuperAdmin ?? false}`);
};

export interface UpdateApiKeysParams {
  apiKey: string;
  description: string;
  withSuperAdmin?: boolean;
}

/**
 * 更新api key的简介信息
 * @param params
 * @returns
 */
export const updateApiKeys = (params: UpdateApiKeysParams) => {
  const { apiKey, ...rest } = params;
  const { put } = Http.use();
  return put(`/auth/keys/${apiKey}`, rest);
};
